<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/product-variation-list/shared/master-product-variation/master-product-variation.component.ts
-->
<ng-template #anchor></ng-template>
